import type { UscLoadSaveCodeType } from "../../utils/tyCodeUtils";

export const USC_SAVE_SET_CODE = "save/setCode";
export const USC_SAVE_SET_SAVING = "save/setSaving";
export const USC_SAVE_SET_FAILED = "save/setFailed";
export const USC_SAVE_INVALIDATE_CODE = "save/invalidateCode";

type SetCode = {
    type: typeof USC_SAVE_SET_CODE;
    data: UscLoadSaveCodeType;
};

type SetSaving = {
    type: typeof USC_SAVE_SET_SAVING;
};

type SetFailed = {
    type: typeof USC_SAVE_SET_FAILED;
};

type InvalidateCode = {
    type: typeof USC_SAVE_INVALIDATE_CODE;
};

export const setCode = (data: UscLoadSaveCodeType): SetCode => ({ type: USC_SAVE_SET_CODE, data });
export const setSaving = (): SetSaving => ({ type: USC_SAVE_SET_SAVING });
export const setFailed = (): SetFailed => ({ type: USC_SAVE_SET_FAILED });
export const invalidateCode = (): InvalidateCode => ({ type: USC_SAVE_INVALIDATE_CODE });

export type UscSaveActionsType = SetCode | SetSaving | SetFailed | InvalidateCode;
